import depotRoutes from './routes/depot/index';
// import mantle from './routes/mantle';
import oneTwoFiveRoutes from './routes/onetwofive/index';

export const apiClientRoutes = {
    depotRoutes,
    // mantle,
    oneTwoFiveRoutes
};
